import { render, staticRenderFns } from "./SignupLoading.vue?vue&type=template&id=4c675f53&scoped=true"
import script from "./SignupLoading.vue?vue&type=script&lang=js"
export * from "./SignupLoading.vue?vue&type=script&lang=js"
import style0 from "./SignupLoading.vue?vue&type=style&index=0&id=4c675f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c675f53",
  null
  
)

export default component.exports